export default "__VITE_ASSET__mqiWhoGf__"